module.exports = __webpack_public_path__ + "static/media/JustEatProviderLogo.eedf54c4.png";